import { useState, useContext } from 'react'
import { LayoutContext } from '../contexts'
import { useShopify } from '../contexts/shopify'
import replaceCheckoutLineItems from '../shopify/replaceCheckoutLineItems'
import { getSegmentAnonymousId } from '../utils'

const useReplaceLineItems = () => {
  const [state, setState] = useState({
    loading: false,
    error: null,
  })

  const activeStoreSubdomain = useContext(LayoutContext)?.storeSubdomain
  const { checkouts, replaceCheckout, stores } = useShopify()

  const replaceLineItems = async (
    input,
    storeSubdomain = activeStoreSubdomain,
  ) => {
    const segmentId = await getSegmentAnonymousId()

    // input is an array of line items with variantId and quantity
    if (input) {
      const checkout = checkouts[storeSubdomain]
      const { client } = stores[storeSubdomain]
      setState({
        loading: true,
        error: null,
      })

      try {
        const mappedLineItems = checkout.lineItems.edges.map(
          ({
            node: {
              variant: { id: variantId },
              quantity,
              customAttributes,
            },
          }) => {
            return { variantId, quantity, customAttributes }
          },
        )
        // merge input array into mappedLineItems
        // if ducplicate, overwrite with added quantities
        input.forEach((product) => {
          const match = mappedLineItems.find(
            ({ variantId }) => variantId === product.variantId,
          )
          if (match) {
            Object.assign(match, {
              variantId: product.variantId,
              quantity: product.quantity + match.quantity,
              customAttributes,
            })
          } else {
            mappedLineItems.push(product)
          }
        })

        const {
          data: {
            checkoutLineItemsReplace: {
              checkout: { id, webUrl, lineItems, customAttributes },
            },
          },
        } = await replaceCheckoutLineItems(client, {
          checkoutId: checkout.id,
          lineItems: mappedLineItems,
        })

        setState({
          loading: false,
          error: null,
        })
        replaceCheckout(
          {
            ...checkout,
            id,
            webUrl,
            lineItems,
            customAttributes,
          },
          segmentId,
        )
      } catch (error) {
        setState({
          loading: false,
          error,
        })
      }
    } else {
      setState({
        loading: false,
        error: new Error('The "input" is missing.'),
      })
    }
  }

  return [replaceLineItems, state]
}

export default useReplaceLineItems
